import { render } from "./final.vue?vue&type=template&id=a4e7ba76&ts=true"
import script from "./final.ts?vue&type=script&lang=ts&external"
export * from "./final.ts?vue&type=script&lang=ts&external"

import "./final.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__